import React, { Fragment, Component } from 'react';
import { translate } from '../Services/translation';

const FacetedSearchGroup = (props) => {
    const { group, searchFacetChange, onClick, open } = props

    return <Fragment>
        <div className="sub-filter-wrapper">
            <div className={"field-wrapper faceted-search__group " + (open ? "faceted-search__group--open" : "faceted-search__group--collapsed")}>
                <div className="faceted-search__group-header" onClick={onClick}>
                    <h6>{ group.label } {group.selectedOptions.length > 0 ? `(${group.selectedOptions.length})` : ""}</h6>
                    <i className="icon icon-chevron-left"></i>
                </div>
                <div className="checkbox-list">
                {group.options && group.options.map((item, itemIndex, array) => (item.quantity != 0 && item.id != "" && item.label != "" &&
                        <div key={`${item.label}-${itemIndex}`} className="faceted-search__item" role="faceted-search-item">
                            <FacetedFilterCheckbox item={item} group={group} searchFacetChange={searchFacetChange}/>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </Fragment>
}


const FacetedSearch = ({facetFilters, searchFacetChange, navigationTheme}) => {
    const [activeFilterGroup, setActiveFilterGroup] = React.useState(0)

    return navigationTheme !== 'category' && facetFilters && facetFilters.length > 0 ?
        <ul className="faceted-search">
            {facetFilters.map((group, groupIndex, array) => (group.options.filter(i => i.quantity != 0).length > 0 &&
                <FacetedSearchGroup 
                    key={`${group.label}-${groupIndex}`} 
                    group={group} 
                    open={activeFilterGroup == groupIndex} 
                    searchFacetChange={searchFacetChange} 
                    onClick={() => activeFilterGroup != groupIndex ? setActiveFilterGroup(groupIndex) : setActiveFilterGroup(undefined)} />
            ))}
        </ul>
    : null
}

const FacetedFilterCheckbox = ({item, group, searchFacetChange}) => (
    <label className="faceted-search__item-label" >
        <input className="medium" type="checkbox" onChange={event => searchFacetChange(group, item)} checked={group.selectedOptions != null && group.selectedOptions.includes(item.id)} />
            {item.label}
    </label>
)

export default FacetedSearch;
